import { TimePanelSource } from 'owa-time-panel-bootstrap';
import { ClientItemId } from 'owa-client-ids';
import MeetingRequestMessageType from 'owa-service/lib/contract/MeetingRequestMessageType';
import { action } from 'satcheljs';

export const preloadTimePanelData = action('preloadTimePanelData');

export const openTasksView = action(
    'openTasksView',
    (
        source: TimePanelSource,
        taskSubject?: string,
        taskLinkedEmailId?: string,
        extractionId?: string
    ) => ({
        source,
        taskSubject,
        taskLinkedEmailId,
        extractionId,
    })
);

export const openCalendarView = action('openCalendarView', (source: TimePanelSource) => ({
    source,
}));

export const openEventDetailsView = action(
    'openEventDetailsView',
    (source: TimePanelSource, clientItemId: ClientItemId) => ({
        source,
        clientItemId,
    })
);

export const openAttendeeTrackingView = action(
    'openAttendeeTrackingView',
    (source: TimePanelSource, clientItemId: ClientItemId) => ({
        source,
        clientItemId,
    })
);

export const closeAttendeeTrackingView = action(
    'closeAttendeeTrackingView',
    (clientItemId: ClientItemId) => ({ clientItemId })
);

export const openConflictsView = action(
    'openConflictsView',
    (source: TimePanelSource, meeting: MeetingRequestMessageType) => ({ source, meeting })
);

export const closeConflictsView = action('closeConflictsView');
